import {
  RemoveReinsuereRep,
  RemoveReinsuereRepVariables,
} from "_graphql/mutation/__generated__/RemoveReinsuereRep";

import { LocationGenerics } from "router/location";
import { PopUp } from "components";
import { removeReinsurerRep } from "_graphql/visal/mutations/re-insurer";
import toast from "react-hot-toast";
import { useMutation } from "@apollo/client";
import { useSearch } from "react-location";
import {
  DeleteKavaPremiumMemberLimit,
  DeleteKavaPremiumMemberLimitVariables,
} from "_graphql/visal/mutations/__generated__/DeleteKavaPremiumMemberLimit";
import { DELETE_KAVA_PREMIUM_MEMBER_LIMIT } from "_graphql/visal/mutations/premium-limit";

export default function RemoveLimitContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  premiumMemberId?: string;
  refetch?: () => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const [remove, { loading }] = useMutation<
    DeleteKavaPremiumMemberLimit,
    DeleteKavaPremiumMemberLimitVariables
  >(DELETE_KAVA_PREMIUM_MEMBER_LIMIT, {
    refetchQueries: ["GetKavaPremiumMemberLimits"],
  });

  const handleSubmit = async () => {
    await remove({
      variables: {
        premiumMemberLimitId: searchParams?.id || "",
      },
    }).then(({ data }) => {
      if (data?.deleteKavaPremiumMemberLimit) {
        toast.success("Kava Premium Member Limit removed successfully");
        refetch?.();
        setOpen?.(false);
      } else {
        toast.error("Failed to remove Kava Premium Member Limit");
      }
    });
  };

  return (
    <PopUp
      open={open}
      setOpen={setOpen}
      title="Remove Kava Premium Member Limit"
      cancelText="No, Don't Remove  Limit"
      description="This action would completely remove kava premium member limit details from system"
      renderActions={() => (
        <>
          <button
            type="button"
            disabled={loading}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
            onClick={handleSubmit}
          >
            {loading ? "Removing  Limit..." : "Remove Limit"}
          </button>
        </>
      )}
    />
  );
}
